import { useSessionStore } from '@/store/sessionStore';
import { cmd } from '@/session/sessionRuntime';
import { useCountdown, formatMs } from '@/hooks/useCountdown';
import { ROLE_LABEL } from '@/protocol/types';

export function RoleRevealView(): JSX.Element {
  const self = useSessionStore((s) => s.self);
  const deadline = useSessionStore((s) => s.phaseDeadlineAt);
  const selfAcked = useSessionStore((s) => s.selfAcked);
  const setSelfAcked = useSessionStore((s) => s.setSelfAcked);
  const remaining = useCountdown(deadline);

  const role = self?.role ?? null;
  const isChief = self?.isChief ?? (role === 'chief');
  const baseRole = self?.baseRole ?? null;
  const teammates = self?.teammates ?? null;
  const seerToken = self?.seerToken ?? null;

  return (
    <main
      data-testid="role-reveal-view"
      className="mx-auto flex max-w-md flex-col gap-4 p-4"
    >
      <h1 className="text-center text-xl font-bold text-pig-700">正在揭示身份…</h1>

      <section className="rounded-lg bg-white p-4 shadow">
        <div className="text-xs text-gray-500">你的身份</div>
        {role == null ? (
          <div className="py-6 text-center text-gray-400">等待服务端下发…</div>
        ) : (
          <>
            <div
              data-testid="role-card"
              className="mt-1 text-2xl font-bold text-pig-700"
            >
              {ROLE_LABEL[role] ?? role}
              {isChief && role !== 'chief' && (
                <span
                  data-testid="chief-tag"
                  className="ml-2 rounded bg-amber-200 px-2 py-0.5 text-sm text-amber-900"
                >
                  村长
                </span>
              )}
              {isChief && role === 'chief' && (
                <span
                  data-testid="chief-tag"
                  className="ml-2 rounded bg-amber-200 px-2 py-0.5 text-sm text-amber-900"
                >
                  村长
                </span>
              )}
            </div>
            {baseRole && baseRole !== (role as unknown as typeof baseRole) && (
              <div className="mt-1 text-sm text-gray-500">
                底牌：{ROLE_LABEL[baseRole as keyof typeof ROLE_LABEL] ?? baseRole}
              </div>
            )}
            {teammates && teammates.length > 0 && (
              <div data-testid="teammates" className="mt-3 text-sm text-gray-700">
                狼队友：{teammates.join(', ')}
              </div>
            )}
            {seerToken && (
              <div data-testid="seer-token" className="mt-3 text-sm text-gray-700">
                先知：{seerToken}
              </div>
            )}
          </>
        )}
      </section>

      <div
        data-testid="role-reveal-countdown"
        className="text-center text-sm text-gray-500"
      >
        剩余 {formatMs(remaining)}
      </div>

      <button
        data-testid="role-reveal-ack-btn"
        disabled={selfAcked}
        onClick={() => {
          if (selfAcked) return;
          setSelfAcked(true);
          cmd.roleRevealAck();
        }}
        className={
          'h-12 w-full rounded-lg text-base font-semibold text-white shadow ' +
          (selfAcked ? 'bg-gray-400 cursor-not-allowed' : 'bg-pig-600')
        }
      >
        {selfAcked ? '已确认，等待其他玩家' : '我已看完'}
      </button>
    </main>
  );
}
